const info = {
    ZH: { //中文翻译
        review:"\u5BA1\u6838",
        checkResult:"\u6821\u9A8C\u7ED3\u679C",
        doubleClick:"\u53CC\u70B9\u8DF3\u81F3\u9519\u8BEF\u5904",
        view:"\u663E\u793A",
        cancel:"\u53D6\u6D88",
        onlySend :" \u4ec5\u53d1\u9001",
        responsible:"\u6211\u627F\u8BFA\uFF0C\u7EE7\u7EED\u53D1\u9001",
        passReview:"\u901A\u8FC7\u6821\u9A8C",
        send:"\u53D1\u9001",
        submit:"\u63D0\u4EA4",
        innerSubmit:"\u5185\u90E8\u53D1\u5E03",
        publishExt:"\u53D1\u5E03",
        shutdown:"\u5173\u95ED",
        msg:"\u5728\u8FDB\u884C\u4E0B\u4E00\u6B65\u64CD\u4F5C\u524D\uFF0C\u6240\u6709\u5F53\u524D\u51FA\u73B0\u7684\u9519\u8BEF\u9700\u8981\u9884\u5148\u5F97\u5230\u4FEE\u6B63",
        sendSuccess:"MDS\u53D1\u9001\u6210\u529F\uFF01",
        submitSuccess:"MDS\u63D0\u4EA4\u6210\u529F\uFF01",
        innerSubmitSuccess:"MDS\u5185\u90E8\u53D1\u5E03\u6210\u529F\uFF01",
        publishExtSuccess:"MDS\u53D1\u5E03\u6210\u529F\uFF01",
        approveMds 	:"	\u6279\u51C6",
        refusedMds 	:"\u62D2\u7EDD",
        confirm :" \u5982\u679C\u662F\u6279\u51C6\u64CD\u4F5C\u5219\u6279\u51C6\u7684\u5185\u5BB9\u5C06\u65E0\u6CD5\u6062\u590D\uFF0C\u786E\u5B9A\u6267\u884C\u5417\uFF1F",
        pleasechose:"\u8BF7\u9009\u62E9\u4E00\u4E2A\u6761\u4EF6",
        Iresponsible:"\u6211\u516C\u53F8\u90D1\u91CD\u627F\u8BFA\uFF0C\u4F9D\u6258CAMDS\u7CFB\u7EDF\u63D0\u4EA4\u81F3\u5BA2\u6237\u7684\u4EA7\u54C1\u4FE1\u606F\u771F\u5B9E\u3001\u6709\u6548\uFF0C\u5982\u56E0\u4FE1\u606F\u4E0D\u5B9E\u800C\u5BF9\u5BA2\u6237\u4EA7\u751F\u7684\u7ECF\u6D4E\u6216\u58F0\u8A89\u5F71\u54CD\uFF0C\u6211\u516C\u53F8\u613F\u610F\u627F\u62C5\u6709\u5173\u8D23\u4EFB\u3002",
        date:"\u65E5\u671F\uFF1A",
        title:"\u8D23\u4EFB\u627F\u8BFA",
        supplier:"\u4F9B\u5E94\u5546\uFF1A",
        
    },
    EN: { //英文翻译
        review	:"	Check",
        checkResult	:"	Check results",
        doubleClick	:"	Double click to jump to the error",
        view	:"	Display",
        cancel	:"	Cancel",
        onlySend	:"	only send",
        responsible :" Promise ",
        passReview	:"	Check successful",
        send	:"	Send",
        submit	:"	Submit",
        innerSubmit	:"Internal",
        publishExt	:"	Publish",
        shutdown	:"	Close",
        msg	:"All existing errors need to be eliminated before any further processing may take place.",
        sendSuccess:"MDS has been sent successfully!",
        submitSuccess:"MDS has been submitted successfully!",
        innerSubmitSuccess:"MDS has been internally submitted successfully!",
        publishExtSuccess:"MDS has been published successfully\!",
        approveMds 	:"	Accept",
        refusedMds 	:"Reject",
        confirm 	:"Are you sure to accept it? This operation can not be undone.",
        pleasechose	:"Please select one search criteria\!",
        date:"Date:",
        title:"Responsibility commitment",
        supplier:"Supplier:",
        Iresponsible:"Our company solemnly promises that the product information submitted to your company based on CAMDS system is true and effective, and we are willing to bear the relevant responsibility for any economic or reputational impact caused by the inaccurate information to your company!",
    }
  }
  export default info //需要暴露出去
  